import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
} from '@atlassian/ufo-experimental/experience-types';

import type { NavigationExperienceMap } from './types';

// register the new experience key in http://go/perfportal

export const NavigationExperienceId: {
	readonly customizationModalLoad: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Load;
		};
		readonly experienceId: 'customization-modal-load';
		readonly instanceId: undefined;
	};
	readonly customizationModalUpdate: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Experience;
		};
		readonly experienceId: 'customization-modal-update';
		readonly instanceId: undefined;
	};
	readonly globalMoreMenuLoad: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Load;
		};
		readonly experienceId: 'global-more-menu-load';
		readonly instanceId: undefined;
	};
	readonly globalSideNavigationLoad: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.PageSegmentLoad;
			readonly type: ExperienceTypes.Load;
		};
		readonly experienceId: 'global-side-navigation-load';
		readonly instanceId: undefined;
	};
	readonly goalCreate: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Experience;
		};
		readonly experienceId: 'uc-goal-create';
		readonly instanceId: undefined;
	};
	readonly projectCreate: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Experience;
		};
		readonly experienceId: 'uc-project-create';
		readonly instanceId: undefined;
	};
	readonly teamCreate: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.InlineResult;
			readonly type: ExperienceTypes.Experience;
		};
		readonly experienceId: 'uc-team-create';
		readonly instanceId: undefined;
	};
	readonly universalCreateComponentLoad: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.PageSegmentLoad;
			readonly type: ExperienceTypes.Load;
		};
		readonly experienceId: 'uc-component-load';
		readonly instanceId: undefined;
	};
	readonly universalCreatePrefetch: {
		readonly config: {
			readonly performanceType: ExperiencePerformanceTypes.Custom;
			readonly type: ExperienceTypes.Operation;
		};
		readonly experienceId: 'uc-backend-prefetch';
		readonly instanceId: undefined;
	};
} = {
	goalCreate: {
		experienceId: 'uc-goal-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	teamCreate: {
		experienceId: 'uc-team-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	projectCreate: {
		experienceId: 'uc-project-create',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	universalCreateComponentLoad: {
		experienceId: 'uc-component-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
		instanceId: undefined,
	},
	universalCreatePrefetch: {
		experienceId: 'uc-backend-prefetch',
		config: {
			type: ExperienceTypes.Operation,
			performanceType: ExperiencePerformanceTypes.Custom,
		},
		instanceId: undefined,
	},
	globalSideNavigationLoad: {
		experienceId: 'global-side-navigation-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		},
		instanceId: undefined,
	},
	customizationModalLoad: {
		experienceId: 'customization-modal-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	customizationModalUpdate: {
		experienceId: 'customization-modal-update',
		config: {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
	globalMoreMenuLoad: {
		experienceId: 'global-more-menu-load',
		config: {
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId: undefined,
	},
} as const satisfies NavigationExperienceMap;
